import { useCallback } from 'react';
import type React from 'react';

import type { UtilityContext } from '@change-corgi/core/react/utilityContext';
import { useUtilityContext } from '@change-corgi/core/react/utilityContext';

import { LazyComponent } from 'src/app/shared/components/layout/lazy';

import type { FlyerDownloadReskin } from './components/FlyerDownload/index_new';

async function LoadFlyerDownload({
	errorReporter,
}: UtilityContext): Promise<typeof FlyerDownloadReskin | (() => null)> {
	try {
		return (
			await import(
				/* webpackChunkName: "pages/starter-dashboard-qr-code-flyer" */ './components/FlyerDownload/index_new'
			)
		).FlyerDownloadReskin;
	} catch (error) {
		const err = error instanceof Error ? error : new Error('Unknown error: Failed to load FlyerDownload component');
		void errorReporter.report({ error: err, params: { event: 'LoadFlyerDownloadReskin' } });
		return () => null;
	}
}

export const FlyerDownloadLoaderReskin: React.FC = () => {
	const utilityContext = useUtilityContext();
	const loadComponent = useCallback(async () => LoadFlyerDownload(utilityContext), [utilityContext]);

	return <LazyComponent loadComponent={loadComponent} fallback={<div></div>} />;
};
